/** Distance from bottom (px) that still counts as “stuck” — matches AIGrant Bubble.List stickiness spirit. */
export const DOCUMENT_CHAT_NEAR_BOTTOM_PX = 80;

type ScrollMetrics = {
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
};

/** True when viewport is within threshold of the scroll bottom. */
export function isChatNearBottom(
  el: ScrollMetrics,
  thresholdPx: number = DOCUMENT_CHAT_NEAR_BOTTOM_PX,
): boolean {
  return el.scrollHeight - el.scrollTop - el.clientHeight <= thresholdPx;
}
